import request from '@/utils/request';

// 提交分析方案
export function submit(query: object) {
    return request({
      url: '/project/analysis/submit',
      method: 'post',
      data: query,
    });
  }

  // 保存分析方案
export function saveAnalysis(query: object) {
    return request({
      url: '/solution/select/edit',
      method: 'post',
      data: query,
    });
}
  // 分配
export function distributeAnalysis(query: object) {
    return request({
      url: '/project/analysis/distribut',
      method: 'post',
      data: query,
    });
}
// 获取列表
export function getList(query: object) {
  return request({
    url: '/solution/select/list',
    method: 'get',
    params: query,
  });
}
